import {
  NFL_ALL_TIME_GREATS_DEFAULT,
  NFL_ALL_TIME_GREATS_STATS,
  getNflAllTimeGreatsStat,
} from "../constants/nflAllTimeGreats";

export {
  filterLeaderboardRowsByName,
  splitGreatsRows,
  buildGreatsGalleryItems,
  clampGalleryIndex,
  stepGalleryIndex,
  findGalleryIndex,
  reconcileGalleryIndex,
  galleryStepFromKey,
} from "./allTimeGreats";

export const parseNflAllTimeGreatsSearch = (searchParams) => {
  const statParam = searchParams?.get?.("stat");
  const stat = NFL_ALL_TIME_GREATS_STATS[statParam]
    ? statParam
    : NFL_ALL_TIME_GREATS_DEFAULT.stat;
  return { stat };
};

export const serializeNflAllTimeGreatsSearch = ({ stat }) => {
  const resolved = parseNflAllTimeGreatsSearch({
    get: (key) => (key === "stat" ? stat : null),
  });
  const params = new URLSearchParams();
  params.set("stat", resolved.stat);
  return params;
};

export const getNflGreatsQualifier = (statKey) =>
  getNflAllTimeGreatsStat(statKey).qualifier || null;
